import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { Detail } from "../Components/ChannelForm/Detail";
export const CreateChannel = () => {


  return (
    <Box className="main_container">
      <Detail />
    </Box >
  );
};